import api from "app/api/requests/Gallery";
import getChatToken from "app/api/getChatToken";

export const GET_ALBUMS = 'GET_ALBUMS';

export const getAlbums = () => (dispatch: any): any => {
	const token = getChatToken();
	return api.getAlbums(token)
		.then(albums => {
			dispatch({
				type: GET_ALBUMS, payload: albums
			});
		});
}
